import React from "react";
import "./booking-status.scss";

const statusColors: { [key: string]: string } = {
    "Pending": "status-pending",
    "Confirmed": "status-approved",
    "Cancelled": "status-rejected",
    "Completed": "status-paid",
    "Primary": "status-primary",
    "Secondary": "status-secondary"
};

const BookingStatus: React.FC<{ status: string }> = ({ status }) => {
    const displayStatus = status.toLowerCase() === "paid" ? "Confirmed" : status;
    const statusClass = status.toLowerCase() === "paid" ? "status-approved" : statusColors[status];

    return (
        <span
            className={`status-badge  ${statusClass} table-cell-ellipsis`}
        >
            {displayStatus}
        </span>
    );
};

export default BookingStatus;

